import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getParameterByName } from '../../../../helpers/location';
import TopFWidget from '../Widgets/TopWidget'

const TopDashboard = props => (
    <div id="players-dashboard">
        <header className="content-header">
            <h1>
                Top Flop
                <small>dashboard</small>
            </h1>
            <ol className="breadcrumb">
                <li><i className="fa fa-wrench"/> Tools</li>
                <li className="text-bold"><Link to="/topflop">Top</Link></li>
            </ol>
        </header>
        <section className="content">
            <TopFWidget championship={parseInt(getParameterByName('championship', props.location.search), 10)}/>
        </section>
    </div>
);

export default connect(
    () => ({}),
    dispatch => ({ dispatch }),
)(TopDashboard);



// WEBPACK FOOTER //
// ./src/pages/Tools/Topflop/Dashboard/TopDashboard.js